import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_transact_campus_card_event.js";
//#region src/bite_log_transact_campus_card_event_helper.ts
var bite_log_transact_campus_card_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "balance-inquiry-success";
		case 2: return "balance-inquiry-error";
		case 3: return "sale-transaction";
		case 4: return "sale-transaction-error";
		case 5: return "refund-transaction";
		case 6: return "refund-transaction-error";
		case 7: return "authorize-limit-success";
		case 8: return "authorize-limit-error";
		case 9: return "retry-attempt";
		case 10: return "connect-error";
		case 11: return "parse-error";
	}
}
//#endregion
export { bite_log_transact_campus_card_event_helper_exports, name };

//# sourceMappingURL=bite_log_transact_campus_card_event_helper.js.map